import config from 'utils/config';

// Domain-level checks — not user-specific

export var isMindsetEnabledInHub = !!config.mindsetAppUid;
export var isMindsetBankConfigured = !!config.mindsetBankUid;